import * as React from "react";
import { forwardRef } from "react";
const SvgBookableByYou = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 23, height: 23, stroke: "black", strokeOpacity: 0.12 }));
const ForwardRef = forwardRef(SvgBookableByYou);
export { ForwardRef as ReactComponent };
